module.exports = __webpack_public_path__ + "img/camel-comb3-3.e9fc7f66.jpg";